<div class="app-container">
  <nav class="main-nav">
    <div class="nav-brand">
      <img src="klemantina-logo.svg" alt="Klemantina Logo" class="logo-icon">
      <h1>Klemantina</h1>
      <span class="admin-badge">Admin</span>
    </div>
    <!-- Internal nav -->
    <div class="nav-links" *ngIf="!isExternalAdmin">
      <a routerLink="/admin" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Database Changes</a>
      <a routerLink="/admin/database-mappings" routerLinkActive="active">Database Mappings</a>
      <a routerLink="/admin/version-logs" routerLinkActive="active">Version Logs</a>
      <a routerLink="/admin/config-presets" routerLinkActive="active">Config Presets</a>
      <a routerLink="/admin/role-types" routerLinkActive="active">Role Types</a>
      <a routerLink="/admin/databases" routerLinkActive="active">Databases</a>
      <a routerLink="/admin/external-admins" routerLinkActive="active">External Admins</a>
      <a routerLink="/admin/agent-tasks" routerLinkActive="active">Agent Tasks</a>
      <a routerLink="/admin/switch-ports" routerLinkActive="active">Switch 51</a>
    </div>

    <!-- External nav -->
    <div class="nav-links" *ngIf="isExternalAdmin">
      <a routerLink="/admin/version-logs" routerLinkActive="active">Version Logs</a>
      <a routerLink="/admin/clients" routerLinkActive="active">Clients</a>
      <a routerLink="/admin/workstations" routerLinkActive="active">Workstations</a>
      <a routerLink="/admin/login-logs" routerLinkActive="active">Login Logs</a>
      <a routerLink="/admin/rag-documents" routerLinkActive="active">RAG Documents</a>
      <a routerLink="/admin/reports" routerLinkActive="active">Reports</a>
    </div>
    <div class="nav-actions" *ngIf="isExternalAdmin">
      <button class="btn-logout" (click)="logout()">Logout</button>
    </div>
  </nav>
  <div class="main-content">
    <router-outlet />
  </div>
</div>
